<section class="page-wrap animated fadeIn">

  <header class="pattern-header">
    Directions to the Farm
  </header>

  <div class="d-flex justify-content-center align-items-center mb-5">
    <div class="landing-container">
      <div class="on-farm-store">

        <div class="on-farm-store__info flex-1">

          <h2 class=" h2-semibold">
            Visiting the Farm?
          </h2>

          <p class="h6-regular">
            Welcome to our farm in the beautiful foothills of Northwest Georgia! We can't wait to see you, whether
            you're joining us for a fun school field trip, exploring our charming on-farm store, or getting lost in the
            corn maze. Come and create some wonderful memories with us!
          </p>

          <div class="row">

            <div class="col-12 py-2">
              <div class="contact-card">

                <span class="material-symbols-outlined text-primary">
                  location_on
                </span>

                <div class="d-flex flex-column g-2">
                  <span class="h6-bold">
                    Location
                  </span>
                  <span class="h6-regular">
                    Carlton Farms 1276 Cartersville Hwy., Rockmart, GA 30153
                  </span>
                </div>

              </div>
            </div>

            <div class="col-12 col-sm-6 py-2">
              <div class="contact-card">

                <span class="material-symbols-outlined text-primary">
                  call
                </span>

                <div class="d-flex flex-column g-2">
                  <span class="h6-bold">
                    Brad (Tours/Field-trips)
                  </span>
                  <span class="h6-regular">
                    770-546-5179
                  </span>
                </div>

              </div>
            </div>

            <div class="col-12 col-sm-6 py-2">
              <div class="contact-card">

                <span class="material-symbols-outlined text-primary">
                  mail
                </span>

                <div class="d-flex flex-column g-2">
                  <span class="h6-bold">
                    Email
                  </span>
                  <span class="h6-regular">
                    {{'info@carltonfarm.com'}}
                  </span>
                </div>

              </div>
            </div>

          </div>

          <div class="hours">

            <ul class="m-0">
              <li>
                Monday - Saturday 10 am - 6 pm
              </li>
              <li>
                Sunday - CLOSED
              </li>
              <li>
                (Open on Sunday 10 am - 6 pm during October only)
              </li>
            </ul>

          </div>

        </div>

        <iframe loading="lazy" referrerpolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3306.6940269136335!2d-85.01826502336226!3d34.026064073166765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x888aca23a1f0aca7%3A0x54689d15a1e287e9!2s1276%20Cartersville%20Hwy%2C%20Rockmart%2C%20GA%2030153%2C%20USA!5e0!3m2!1sen!2sco!4v1744753389416!5m2!1sen!2sco"></iframe>

      </div>
    </div>
  </div>

</section>